import type { Column } from '@/components/Organisms/DataTable/DataTable.types';
import { priorityOptions, statusFilterOptions } from '../constants';

export const columns: Column[] = [
	{
		key: 'title',
		label: 'Subject',
		width: '130px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'description',
		label: 'Description',
		width: '240px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'prioritycode',
		label: 'Priority',
		width: '80px',
		type: 'string-status',
		sorter: true,
		filterOptions: priorityOptions,
	},
	{
		key: 'createdon',
		label: 'Created On',
		width: '60px',
		type: 'date',
		dateISO: true,
		sorter: true,
	},
	{
		key: 'daysOpen',
		label: 'Days Open',
		width: '55px',
		type: 'number',
		sorter: false,
	},
	{
		key: 'statuscode',
		label: 'Status',
		width: '110px',
		type: 'string-status',
		sorter: true,
		filterOptions: statusFilterOptions,
	},
];





